<template>
  <div class="pickUpingDialog">
    <div class="loading">
      <div><span></span></div>
      <div><span></span></div>
      <div><span></span></div>
    </div>
    <div class="title">智能字幕正在快速生成中...</div>
    <div class="desc">
      视频越长，字幕生成所需时间越久，您可以过一会再来看看哦
    </div>
    <div class="cancel" @click="cancel">取消</div>
  </div>
</template>

<script>
export default {
  name: "pickUpingDialog",
  data () {
    return {};
  },
  props: {},
  components: {},
  methods: {
    cancel () {
      this.$emit("resultHandler");
    }
  },
  watch: {},
  computed: {}
};
</script>

<style scoped lang='scss'>
.pickUpingDialog {
  width: 600px;
  // height: 300px;
  background-color: transparent;
  border: 0px solid black;
  margin: 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .title {
    height: 20px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    margin-top: 40px;
    margin-bottom: 20px;
  }

  .desc {
    height: 17px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    margin-bottom: 30px;
  }

  .cancel {
    color: #333333;
    background-color: #fff;
    border-radius: 4px;
    width: 108px;
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    margin-top: 20px;
    cursor: pointer;

    &:hover {
      color: #ffffff;
      background-color: #5778fb;
    }
  }
}
.loading {
  width: 60px;
  height: 60px;
  margin: 0 auto;
  margin-top: 40px;
  position: relative;
  animation: load 3s linear infinite;
}
.loading div {
  width: 100%;
  height: 100%;
  position: absolute;
}
.loading span {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #FFFFFF;
  position: absolute;
  left: 50%;
  margin-top: -10px;
  margin-left: -10px;
  animation: changeBgColor 3s ease infinite;
}
@keyframes load {
  0% {
    transform: rotate(0deg);
  }
  33.3% {
    transform: rotate(120deg);
  }
  66.6% {
    transform: rotate(240deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes changeBgColor {
  0%,
  100% {
    background: #FFFFFF;
  }
  33.3% {
    background: #7FAFFD;
  }
  66.6% {
    background: #0062FF;
  }
}
.loading div:nth-child(2) {
  transform: rotate(120deg);
}
.loading div:nth-child(3) {
  transform: rotate(240deg);
}
.loading div:nth-child(2) span {
  animation-delay: 1s;
}
.loading div:nth-child(3) span {
  animation-delay: 2s;
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/dialogs/pickUpingDialog.vue